import { createRoot } from "react-dom/client";
import "@fontsource-variable/sora";
import "@fontsource-variable/manrope";
import App from "./App.tsx";
import "./index.css";
import { landingBootGate } from "./lib/landing/early";

const render = () => createRoot(document.getElementById("root")!).render(<App />);
// On landing pages, wait for the early content fetch so the first render already has it.
const gate = landingBootGate();
if (gate) void gate.then(render);
else render();
